<template>
  <v-dialog v-model="dialog">
    <template v-slot:activator="{ on, attrs }">
      <v-btn class="primary" v-bind="attrs" v-on="on">
        {{buttonName}}
      </v-btn>
    </template>
    <pdf :src="path"/>
  </v-dialog>
</template>

<script>
  import pdf from 'vue-pdf'

  export default {
    name: "PdfLoader",
    props: {
      buttonName: {
        type: String,
        default: null
      },
      path: {
        type: String,
        default: null
      }
    },
    data() {
      return {
        dialog: false
      }
    },
    components: {
      pdf
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/PdfLoader.vue